import React from 'react';
import marked from 'marked';
import { BoxComponentProps } from '../../boxTypes';
import './Simple.style.scss';
import './responsive.scss';

export const templateName = 'simple';
export const templateID = 'tk-showcase-simple-01';
export const colors = [
  { colorValue: '#364962', colorLabel: 'Title Color' },
  { colorValue: '#6366f1', colorLabel: 'Subtitle Color' },
  { colorValue: '#2e353f', colorLabel: 'Content Color' },
  {
    colorValue:
      '#ff9816 linear-gradient(to right bottom,rgb(250, 204, 21),rgb(249, 115, 22))',
    colorLabel: 'CTA Color',
  },
  {
    colorValue: 'linear-gradient(to right bottom, #38bdf8, #6366f1)',
    colorLabel: 'Ribbon Color',
  },
];

const Simple: React.FC<BoxComponentProps> = ({ formData, isPreview }) => {
  const { fieldData } = formData;
  if (!formData.fieldData.length) return null;
  const {
    buyButtonText,
    imageURL,
    productBody,
    productSubtitle,
    productTitle,
    productURL,
    ribbonText,
    externalLink,
  } = fieldData[0]?.fields;

  return (
    <div
      id="tableskit"
      className={`tableskit tk-${templateName} ${templateID}`}
    >
      {ribbonText && <div className="tk-ribbon">{ribbonText}</div>}
      <div className="tk-simple-card">
        <div className="tk-card-image">
          <a href={productURL}>
            <img src={imageURL} alt={productTitle} />
          </a>
        </div>

        <div className="tk-card-body">
          <h2 className="card-title">{productTitle}</h2>
          <div className="card-subtitle">{productSubtitle}</div>
          <div
            dangerouslySetInnerHTML={{
              __html: marked(productBody || ''),
            }}
            className="product-body"
          />

          <a
            href={productURL}
            target={externalLink || isPreview ? '_blank' : undefined}
            className="buy-btn"
            rel="noreferrer"
          >
            {buyButtonText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Simple;
